export default {"src":"/_next/static/media/smirk-face.c2395686.svg","height":54,"width":54,"blurWidth":0,"blurHeight":0};